import { CallResult } from '../../../Api/callExternalApi';
import {
  ChangeCustomFieldTypeRequest,
  updateCustomFieldDefinitionApi
} from '../../../Api/Admin/CustomFields/customFieldDefinitionsApi';
import { CustomFieldDefinition } from '../../../types';
import { DATA_TYPE_LIST, DataTypeValue } from '../../../utils/customFieldTypes';

export type FieldTypeSaveRow = {
  systemKey?: string;
  fieldType: DataTypeValue;
  originalFieldType: DataTypeValue;
  choices: string[];
};

type ChangeResult = CallResult<CustomFieldDefinition> & { cancelled?: boolean };
export type ChangeFieldType = (id: string, request: ChangeCustomFieldTypeRequest) => Promise<ChangeResult>;

// A type change carries List choices on its own route; choices alone go through the definition update.
// Null means nothing needed saving, so a caller keeps its baseline as it was.
export const saveFieldTypeOrChoices = async (
  definitionId: string,
  row: FieldTypeSaveRow,
  choicesChanged: boolean,
  changeFieldType: ChangeFieldType
): Promise<ChangeResult | null> => {
  if (row.fieldType !== row.originalFieldType) {
    return changeFieldType(definitionId, {
      new_field_type: row.fieldType,
      new_options: row.fieldType === DATA_TYPE_LIST ? { choices: row.choices } : undefined
    });
  }
  if (row.fieldType === DATA_TYPE_LIST && choicesChanged) {
    const options = row.systemKey ? { system_key: row.systemKey, choices: row.choices } : { choices: row.choices };
    return updateCustomFieldDefinitionApi(definitionId, { options });
  }
  return null;
};
